<template>
  <k-dialog @close="cancel" :max-height="400" :max-width="400" :title="action">
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Client Name :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'clientName'"
              v-model="clientInEdit.clientName"
              class="form-control"
              :required="true"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label"> Client ID : </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'clientId'"
              v-model="clientInEdit.clientId"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
        <div
          v-if="!clientInEdit.id"
          class="form-group row"
          :style="{ marginBottom: '1rem' }"
        >
          <label class="col-sm-3 text-left col-form-label">
            Client Secrets :
          </label>
          <div class="col-sm-9">
            <k-input
              :name="'clientSecrets'"
              type="text"
              :placeholder="'Enter comma  seperated values'"
              v-model="clientInEdit.clientSecrets"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allow Access Tokens Via Browser?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.allowAccessTokensViaBrowser"
              :messages="messages"
              v-model="clientInEdit.allowAccessTokensViaBrowser"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Redirect URI :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'redirectUris'"
              :placeholder="'https://website.com/silent-renew-oidc, https://website.com/callback'"
              v-model="clientInEdit.redirectUris"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allowed CORS Origin :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'allowedCorsOrigins'"
              :placeholder="'https://website.com'"
              v-model="clientInEdit.allowedCorsOrigins"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allowed Scopes :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              ref="scopeMultiselect"
              :data-source="scopesList"
              v-model="clientInEdit.allowedScopes"
              :placeholder="'Select Scopes...'"
              :filter="'contains'"
              class="form-control"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div v-if="!clientInEdit.id" class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allowed Grant Types :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              ref="grantMultiselect"
              :data-source="grantsList"
              v-model="clientInEdit.allowedGrantTypes"
              :placeholder="'Select Grants...'"
              :filter="'contains'"
              class="form-control"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allowed Roles :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              ref="roleMultiselect"
              :data-source="rolesList"
              v-model="clientInEdit.allowedRoles"
              :data-text-field="'roleName'"
              :data-value-field="'roleName'"
              :value-primitive="true"
              :placeholder="'Select Roles...'"
              :filter="'contains'"
              class="form-control"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Post Logout Redirect Uri :
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'postLogoutRedirectUris'"
              placeholder="https://website.com/logoutSuccess"
              v-model="clientInEdit.postLogoutRedirectUris"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Always Include User Claims in ID Token?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.alwaysIncludeUserClaimsInIdToken"
              :messages="messages"
              v-model="clientInEdit.alwaysIncludeUserClaimsInIdToken"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Always Send Client Claims?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.alwaysSendClientClaims"
              :messages="messages"
              v-model="clientInEdit.alwaysSendClientClaims"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Require Consent?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.requireConsent"
              :messages="messages"
              v-model="clientInEdit.requireConsent"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Is Tenant Based?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.isTenantBased"
              :messages="messages"
              v-model="clientInEdit.isTenantBased"
              :name="'isTenantBased'"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Require Client Secret?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.requireClientSecret"
              :messages="messages"
              v-model="clientInEdit.requireClientSecret"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Allow Offline Access?
          </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="clientInEdit.allowOfflineAccess"
              :messages="messages"
              v-model="clientInEdit.allowOfflineAccess"
            ></kendo-switch>
          </div>
        </div>
      </div>

      <input type="submit" id="submit-form" class="d-none" />
    </form>
<div class="d-flex ">
      <button class="k-button col-6" @click="cancel" >Cancel</button>
      <label class="k-button k-primary col-6 mb-0" for="submit-form" tabindex="0"
        >Save</label
      >
</div>
  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { Input } from "@progress/kendo-vue-inputs";
import { MultiSelect } from "@progress/kendo-dropdowns-vue-wrapper";
import { Switch } from "@progress/kendo-inputs-vue-wrapper";
import { oidcSettings } from "../../services/store";
import  '@progress/kendo-ui/js/kendo.core';
import  '@progress/kendo-ui/js/kendo.switch';
import  '@progress/kendo-ui/js/kendo.data';
import  '@progress/kendo-ui/js/kendo.multiselect';

export default {
  components: {
    "k-input": Input,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    "kendo-multiselect": MultiSelect,
    "kendo-switch": Switch,
  },
  props: {
    dataItem: Object,
    dialogTitle: String,
    scopesList: Array,
    grantsList: Array,
    rolesList: Array,
  },
  data: function () {
    return {
      clientInEdit: {
        clientName: "",
        clientSecrets: "",
        allowedGrantTypes: [],
        allowAccessTokensViaBrowser: false,
        alwaysIncludeUserClaimsInIdToken: false,
        alwaysSendClientClaims: false,
        requireConsent: false,
        redirectUris: "",
        allowedCorsOrigins: "",
        postLogoutRedirectUris: "",
        allowedScopes: [],
        identityPoolID: "",
        isTenantBased: false,
        allowedRoles: [],
      },
      base_url: undefined,
      action: "",
      multiselectValue: [],
      messages: {
        checked: "Yes",
        unchecked: "No",
      },
    };
  },
  validations: {
    clientInEdit: {},
  },
  created: function () {
    if (this.$props.dataItem) {
      this.clientInEdit = this.$props.dataItem;
      console.log(this.$props.dataItem);
    }
    this.action = this.$props.dialogTitle;
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";

    // this.getScopesList();
  },
  mounted: function () {
    if (this.clientInEdit.allowedRoles != undefined) {
      var roleMS = this.$refs.roleMultiselect.kendoWidget();
      var roles = this.clientInEdit.allowedRoles.map((role) =>
        this.$props.rolesList.find((r) => r.roleName == role)
      );
      roleMS.value(roles);
      console.log(roles);
      console.log(roleMS.value());
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (
        !(
          Array.isArray(this.clientInEdit.allowedRoles) &&
          this.clientInEdit.allowedRoles.length &&
          Array.isArray(this.clientInEdit.allowedScopes) &&
          this.clientInEdit.allowedScopes.length &&
          Array.isArray(this.clientInEdit.allowedGrantTypes) &&
          this.clientInEdit.allowedGrantTypes.length
        )
      ) {
        alert("Please Select the Values");
        return;
      }

      console.log("SAVED");
      if (this.action == "Edit Client") {
        this.$emit("save");
      } else {
        this.$emit("save");
      }
    },
    corsToArray(val) {
      this.clientInEdit.allowedCorsOrigins = val.split(",");
      console.log(val.split(","));
    },
  },
};
</script>
<style scoped>
.k-widget.k-window.k-dialog {
  overflow: auto;
}
</style>